// Always use current domain for API calls - works on preview, deployed, and custom domains
const API_BASE = window.location.origin;
export const API = `${API_BASE}/api`;
export const resolveImg = (url) => url || "";
